module.exports = __webpack_public_path__ + "static/compchart3.cbd5dfd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/compchart3.jpg
// module id = 3062
// module chunks = 94883237073720